const data = [
  {
    id: 'zero',
    paths: [
      {
        path: 'm 0,0 c -17.746,55.543 -49.49,87.446 -81.136,87.555 -47.635,-0.165 -94.61,-72.37 -94.61,-188.818 0,-116.45 44.884,-188.82 94.61,-188.82 49.727,0 95.496,72.37 95.496,188.82 C 14.36,-62.172 8.969,-28.067 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 918.6231689453125,

        transform: 'translate(478.7334,521.8418)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641',
        transform: 'translate(350.1421,612.6753)',
      },
      {
        path: 'M 0,0 C -30.719,48.322 -82.548,22.098 -93.251,0',
        transform: 'translate(445.4805,615.8994)',
      },
      {
        path: 'M 0,0 C -0.727,-0.027 -0.5,-1.543 0.03,-2.042 0.694,-2.663 1.739,-2.63 2.363,-1.969 3.143,-1.143 3.102,0.157 2.273,0.934 1.235,1.905 -0.396,1.855 -1.371,0.822 -2.59,-0.469 -2.167,-2.311 -1.23,-3.127 0.273,-4.441 4.248,-3.312 2.821,0.072',
        transform: 'translate(444.9795,616.6289)',
      },
    ],
  },
  {
    id: 'one',
    paths: [
      {
        path: 'M 0,0 78.934,94.674',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 123.26290130615234,

        transform: 'translate(341.7007,513.3452)',
      },
      {
        path: 'M 0,0 V -377.536',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 377.5360107421875,

        transform: 'translate(420.6348,608.019)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.428,6.172 -2.286,10.76 -2.286,10.76M 0,0 C 1.635,6.12 3.031,10.571 3.031,10.571',
        transform: 'translate(440.6348,524.1704)',
      },
      {
        path: 'M 0,0 0.004,74.604',
        transform: 'translate(440.8027,528.1362)',
      },
      {
        path: 'M 0,0 C -2.874,-5.644 -5.164,-9.712 -5.164,-9.712M 0,0 C -5.186,-3.635 -9.116,-6.151 -9.116,-6.151',
        transform: 'translate(383.9468,583.1982)',
      },
      {
        path: 'M 0,0 -47.954,-57.148',
        transform: 'translate(381.269,580.2695)',
      },
      {
        path: 'M 0,0 C -0.727,-0.027 -0.5,-1.543 0.03,-2.042 0.694,-2.663 1.739,-2.63 2.363,-1.969 3.143,-1.143 3.102,0.157 2.273,0.934 1.235,1.905 -0.396,1.855 -1.371,0.822 -2.59,-0.469 -2.167,-2.311 -1.23,-3.127 0.273,-4.441 4.248,-3.312 2.821,0.072',
        transform: 'translate(330.6416,521.2617)',
      },
    ],
  },
  {
    id: 'two',
    paths: [
      {
        path: 'm 0,0 c 8.063,17.496 20.87,36.077 43.955,47.618 18.082,9.453 37.493,12.273 56.73,6.97 27.91,-7.88 40.822,-22.757 52.092,-49.773 7.474,-25.565 1.165,-51.766 -10.103,-76.653 -12.126,-23.232 -26.066,-44.294 -39.005,-65.533 -23.482,-31.173 -47.925,-62.826 -72.65,-93.07 -11.608,-14.756 -21.397,-31.355 -30.191,-48.607 -4.814,-12.45 -11.214,-26.816 -9.899,-39.403',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 571.563720703125,

        transform: 'translate(317.3418,551.5879)',
      },
      {
        path: 'M 0,0 C 0.792,-2.359 4.522,-2.729 6.692,-1.605 99.926,43.687 103.847,-27.16 173.525,8.112',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 181.09144592285156,

        transform: 'translate(308.271,233.1367)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.073,1.802 -10.489,3.318 -10.489,3.318M 0,0 C -4.518,4.44 -7.703,7.851 -7.703,7.851',
        transform: 'translate(406.9482,221.5645)',
      },
      {
        path: 'M 0,0 C 0,0 -27.985,27.785 -90.67,-5.781',
        transform: 'translate(405.502,222.2803)',
      },
      {
        path: 'M 0,0 C -5.932,-2.24 -10.362,-3.708 -10.362,-3.708M 0,0 C -6.289,0.802 -10.889,1.586 -10.889,1.586',
        transform: 'translate(366.2622,616.4658)',
      },
      {
        path: 'M 0,0 C -16.672,-1.369 -47.743,-20.324 -61.518,-55.158',
        transform: 'translate(363.1958,616.1978)',
      },
      {
        path: 'M 0,0 C -0.722,-0.086 -0.372,-1.579 0.197,-2.032 0.91,-2.597 1.949,-2.479 2.517,-1.769 3.226,-0.882 3.079,0.41 2.189,1.117 1.076,2 -0.546,1.816 -1.434,0.708 -2.542,-0.679 -1.971,-2.48 -0.97,-3.217 c 1.606,-1.187 5.475,0.264 3.776,3.52',
        transform: 'translate(301.5449,562.0381)',
      },
    ],
  },
  {
    id: 'three',
    paths: [
      {
        path: 'm 0,0 c 16.143,29.271 39.111,38.551 63.611,40.021 50.015,2.967 80.596,-41.343 79.785,-91.521 -0.822,-50.165 -33.061,-93.248 -79.117,-93.248 H 48.323',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 367.8338928222656,

        transform: 'translate(325.4536,568.5449)',
      },
      {
        path: 'm 0,0 h 16.61 c 39.152,0.499 96.91,-38.18 95.75,-95.75 -1.147,-57.597 -44.594,-95.581 -94.104,-95.581 -24.015,0 -51.649,8.902 -75.985,30.431',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 398.5706481933594,

        transform: 'translate(373.4453,423.7969)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.437,3.268 -9.333,5.836 -9.333,5.836M 0,0 C -3.272,5.433 -5.507,9.528 -5.507,9.528',
        transform: 'translate(432.8242,384.7158)',
      },
      {
        path: 'M 0,0 C -10.33,11.281 -30.734,22.48 -55.724,22.562',
        transform: 'translate(429.9551,387.416)',
      },
      {
        path: 'M 0,0 C -5.827,-2.501 -10.188,-4.164 -10.188,-4.164M 0,0 C -6.318,0.522 -10.95,1.101 -10.95,1.101',
        transform: 'translate(361.6489,617.3306)',
      },
      {
        path: 'M 0,0 C -11.65,-1.073 -34.339,-14.863 -43.787,-33.077',
        transform: 'translate(358.0049,616.8257)',
      },
      {
        path: 'M 0,0 C -0.727,-0.027 -0.5,-1.543 0.03,-2.042 0.694,-2.663 1.739,-2.63 2.363,-1.969 3.143,-1.143 3.102,0.157 2.273,0.934 1.235,1.905 -0.396,1.855 -1.371,0.822 -2.59,-0.469 -2.167,-2.311 -1.23,-3.127 0.273,-4.441 4.248,-3.312 2.821,0.072',
        transform: 'translate(312.4438,583.8208)',
      },
    ],
  },
  {
    id: 'four',
    paths: [
      {
        path: 'M 0,0 C -39.938,-98.863 -59.589,-144.851 -87.905,-215.076',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 232.3472442626953,

        transform: 'translate(402.1504,608.3643)',
      },
      {
        path: 'M 0,0 H 164.253',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.2530059814453,

        transform: 'translate(314.2456,393.2881)',
      },
      {
        path: 'M 0,0 V -211.328',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 211.3280029296875,

        transform: 'translate(450.5049,442.4614)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.423,6.172 -2.286,10.761 -2.286,10.761M 0,0 C 1.638,6.121 3.034,10.57 3.034,10.57',
        transform: 'translate(471.0664,300.6084)',
      },
      {
        path: 'M 0,0 0.005,74.608',
        transform: 'translate(471.2334,304.5752)',
      },
      {
        path: 'M 0,0 C -6.172,-1.424 -10.76,-2.287 -10.76,-2.287M 0,0 C -6.12,1.637 -10.57,3.033 -10.57,3.033',
        transform: 'translate(391.2012,376.6543)',
      },
      {
        path: 'M 0,0 -74.6,0.004',
        transform: 'translate(387.2349,376.8213)',
      },
      {
        path: 'M 0,0 C 0.99,6.256 1.911,10.832 1.911,10.832M 0,0 C 3.81,5.06 6.771,8.664 6.771,8.664',
        transform: 'translate(347.4653,531.1523)',
      },
      {
        path: 'M 0,0 27.951,69.17',
        transform: 'translate(349.1064,534.7656)',
      },
      {
        path: 'M 0,0 C -0.727,-0.027 -0.5,-1.543 0.03,-2.042 0.694,-2.663 1.739,-2.63 2.363,-1.969 3.143,-1.143 3.102,0.157 2.273,0.934 1.235,1.905 -0.396,1.855 -1.372,0.822 -2.591,-0.469 -2.168,-2.31 -1.231,-3.127 0.273,-4.441 4.248,-3.312 2.821,0.072',
        transform: 'translate(376.3926,604.896)',
      },
    ],
  },
  {
    id: 'five',
    paths: [
      {
        path: 'M 0,0 V -184.214',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 184.21400451660156,

        transform: 'translate(327.1489,608.6479)',
      },
      {
        path: 'm 0,0 c 15.981,10.845 35.807,20.484 54.462,22.81 59.119,7.828 106.913,-30.637 100.921,-107.235 -5.988,-76.636 -43.966,-108.11 -100.921,-108.11 -25.651,0 -44.307,6.489 -65.785,20.497',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 468.97613525390625,

        transform: 'translate(327.1489,424.4341)',
      },
      {
        path: 'M 0,0 C 47.931,-20.732 100.794,-26.459 146.394,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 152.05406188964844,

        transform: 'translate(327.1489,608.6479)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.258,-0.98 -10.896,-1.506 -10.896,-1.506M 0,0 C -5.984,2.071 -10.325,3.783 -10.325,3.783',
        transform: 'translate(407.499,603.8384)',
      },
      {
        path: 'M 0,0 C 0,0 -48.861,5.045 -74.602,20.509',
        transform: 'translate(403.875,604.1973)',
      },
      {
        path: 'M 0,0 C -6.152,1.535 -10.631,2.85 -10.631,2.85M 0,0 C -4.715,4.239 -8.051,7.502 -8.051,7.502',
        transform: 'translate(431.5967,421.6489)',
      },
      {
        path: 'M 0,0 C -28.903,15.636 -74.287,6.349 -97.647,-16.963',
        transform: 'translate(428.3887,423.4395)',
      },
      {
        path: 'M 0,0 C -1.427,6.171 -2.285,10.759 -2.285,10.759M 0,0 C 1.636,6.117 3.031,10.571 3.031,10.571',
        transform: 'translate(306.5063,524.1421)',
      },
      {
        path: 'M 0,0 0.004,74.604',
        transform: 'translate(306.6743,528.1079)',
      },
      {
        path: 'M 0,0 C -0.727,-0.027 -0.5,-1.543 0.03,-2.042 0.694,-2.663 1.739,-2.63 2.363,-1.969 3.143,-1.143 3.102,0.157 2.273,0.934 1.235,1.905 -0.396,1.855 -1.371,0.822 -2.59,-0.469 -2.167,-2.311 -1.23,-3.127 0.273,-4.441 4.248,-3.312 2.821,0.072',
        transform: 'translate(306.3848,604.3877)',
      },
    ],
  },
  {
    id: 'six',
    paths: [
      {
        path: 'm 0,0 c -14.531,21.48 -47.588,33.404 -71.644,29.063 -16.693,-3.012 -34.173,-8.422 -48.026,-25.927 -24.263,-26.4 -39.612,-88.135 -39.782,-167.361 0,-19.174 0.507,-60.761 2.169,-79.578',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 391.7579040527344,

        transform: 'translate(468.3896,578.8115)',
      },
      {
        path: 'm 0,0 c -0.068,-1.905 -0.102,-3.829 -0.102,-5.769 0,-65.693 39.287,-112.898 87.475,-112.898 48.196,0 87.315,47.205 87.315,112.898 0,65.706 -39.119,112.916 -87.315,112.916 C 40.608,107.147 2.225,62.682 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 634.3404541015625,

        transform: 'translate(310.9258,350.3496)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.725,5.13 -6.623,8.789 -6.623,8.789M 0,0 C -5.695,2.783 -9.97,4.655 -9.97,4.655',
        transform: 'translate(331.8877,244.9668)',
      },
      {
        path: 'M 0,0 C -24.303,17.489 -40.131,54.089 -38.106,103.646',
        transform: 'translate(329.3027,247.2441)',
      },
      {
        path: 'M 0,0 C 6.34,-0.106 11.006,0.009 11.006,0.009M 0,0 C 5.649,2.877 9.715,5.168 9.715,5.168',
        transform: 'translate(386.958,621.2163)',
      },
      {
        path: 'M 0,0 C 39.417,7.013 57.728,-2.05 86.728,-25.979',
        transform: 'translate(390.5161,622.4019)',
      },
      {
        path: 'm 0,0 c -0.727,0.007 -0.57,-1.519 -0.064,-2.041 0.634,-0.651 1.68,-0.667 2.334,-0.035 0.817,0.789 0.835,2.089 0.044,2.904 -0.992,1.018 -2.623,1.044 -3.645,0.057 -1.277,-1.233 -0.94,-3.093 -0.043,-3.952 1.441,-1.382 5.465,-0.438 4.196,3.008',
        transform: 'translate(476.749,597.4575)',
      },
    ],
  },
  //
  {
    id: 'seven',
    paths: [
      {
        path: 'M 0,0 C 63.937,73.771 109.282,-21.658 164.257,28.564',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 179.86964416503906,

        transform: 'translate(316.041,579.4272)',
      },
      {
        path: 'M 0,0 -152.461,-376.292',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 406.00494384765625,

        transform: 'translate(480.2979,607.9917)',
      },
      {
        path: 'M 0,0 H 71.048',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 71.0479965209961,

        transform: 'translate(364.2036,409.4561)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.171,-1.423 -10.758,-2.287 -10.758,-2.287M 0,0 C -6.118,1.637 -10.568,3.033 -10.568,3.033',
        transform: 'translate(392.8843,399.5405)',
      },
      {
        path: 'M 0,0 -24.424,0.004',
        transform: 'translate(388.9189,399.7075)',
      },
      {
        path: 'M 0,0 C 0.99,6.256 1.91,10.832 1.91,10.832M 0,0 C 3.811,5.06 6.772,8.664 6.772,8.664',
        transform: 'translate(468.1631,531.1523)',
      },
      {
        path: 'M 0,0 27.953,69.17',
        transform: 'translate(469.8037,534.7656)',
      },
      {
        path: 'M 0,0 C -6.172,-1.424 -10.76,-2.287 -10.76,-2.287M 0,0 C -6.12,1.637 -10.57,3.033 -10.57,3.033',
        transform: 'translate(372.9722,626.3447)',
      },
      {
        path: 'M 0,0 C -36.083,1.75 -64.459,-31.201 -64.459,-31.201',
        transform: 'translate(369.0786,626.4082)',
      },
      {
        path: 'M 0,0 C -0.727,-0.027 -0.5,-1.543 0.03,-2.042 0.694,-2.663 1.739,-2.63 2.363,-1.969 3.143,-1.143 3.102,0.157 2.273,0.934 1.235,1.905 -0.396,1.855 -1.372,0.822 -2.591,-0.469 -2.168,-2.31 -1.231,-3.127 0.273,-4.441 4.248,-3.312 2.821,0.072',
        transform: 'translate(302.8408,596.2207)',
      },
    ],
  },
  {
    id: 'eight',
    paths: [
      {
        path: 'm 0,0 c -14.307,10.479 -31.869,16.71 -50.302,16.71 v -0.002 c -44.944,0 -83.109,-37.031 -83.109,-82.394 0,-36.895 27.006,-68.576 59.192,-80.566 22.008,-8.2 36.802,-14.53 45.757,-18.852 0.779,-0.377 2.146,-0.906 3.974,-1.633',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 343.621826171875,

        transform: 'translate(447.7314,591.4785)',
      },
      {
        path: 'm 0,0 c 16.245,-6.458 68.897,-28.523 69.494,-97.824 0.457,-52.814 -42.76,-95.963 -95.075,-95.963 h 1.146 c -52.317,0 -95.541,43.149 -95.084,95.963 0.662,77.103 65.767,95.734 73.477,99.456 8.955,4.32 23.75,10.653 45.758,18.853 32.179,11.99 59.185,43.671 59.185,80.564 0,26.758 -13.838,50.618 -34.413,65.688',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 795.0562744140625,

        transform: 'translate(423.2432,424.7417)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 4.147,-4.792 7.051,-8.446 7.051,-8.446M 0,0 C 1.415,-6.175 2.262,-10.764 2.262,-10.764',
        transform: 'translate(291.0005,300.5645)',
      },
      {
        path: 'M 0,0 C 5.578,-14.833 15.21,-29.737 26.971,-43.146',
        transform: 'translate(292.9673,297.083)',
      },
      {
        path: 'M 0,0 C -5.79,2.576 -9.972,4.65 -9.972,4.65M 0,0 C -3.904,4.989 -6.622,8.783 -6.622,8.783',
        transform: 'translate(466.0596,378.6035)',
      },
      {
        path: 'M 0,0 C -11.353,11.057 -26.406,20.455 -42.749,27.593',
        transform: 'translate(462.7998,380.9199)',
      },
      {
        path: 'M 0,0 C 6.12,1.659 10.571,3.064 10.571,3.064M 0,0 C 4.628,4.333 7.897,7.663 7.897,7.663',
        transform: 'translate(366.0664,616.0747)',
      },
      {
        path: 'M 0,0 C 14.316,8.655 52.096,18.047 81.777,-6.362',
        transform: 'translate(369.354,617.8027)',
      },
      {
        path: 'm 0,0 c 0.634,0.353 1.226,-1.062 1.029,-1.763 -0.247,-0.875 -1.158,-1.388 -2.034,-1.145 -1.094,0.304 -1.731,1.437 -1.425,2.531 0.386,1.368 1.808,2.169 3.177,1.79 1.711,-0.475 2.302,-2.269 1.922,-3.454 -0.606,-1.902 -4.592,-2.991 -5.121,0.642',
        transform: 'translate(450.6553,612.3281)',
      },
    ],
  },
  {
    id: 'nine',
    paths: [
      {
        path: 'm 0,0 c -14.096,13.283 -31.448,20.844 -50.148,20.844 -46.916,0 -85.081,-47.26 -85.081,-113.037 0,-65.765 38.165,-113.019 85.081,-113.019 46.739,0 85.099,47.254 85.099,113.019 C 34.951,-52.738 21.154,-19.937 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 627.8870239257812,

        transform: 'translate(446.7139,587.521)',
      },
      {
        path: 'm 0,0 c 1.269,-21.937 2.467,-57.744 2.467,-76.924 0,-103.051 -9.612,-136.662 -34.454,-170.274 -13.3,-17.994 -35.989,-22.429 -53.406,-23.903 -21.206,-1.794 -47.555,9.272 -65.491,22.35 -4.228,3.083 -6.815,6.423 -7.755,8.9',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 396.7866516113281,

        transform: 'translate(481.5244,502.1851)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.209,6.22 -1.909,10.835 -1.909,10.835M 0,0 C 1.847,6.06 3.397,10.463 3.397,10.463',
        transform: 'translate(501.9873,435.209)',
      },
      {
        path: 'M 0,0 C 0.921,5.657 -0.036,41.519 -1.917,50.845',
        transform: 'translate(502.0166,439.2075)',
      },
      {
        path: 'M 0,0 C 6.153,1.535 10.631,2.85 10.631,2.85M 0,0 C 4.715,4.238 8.05,7.502 8.05,7.502',
        transform: 'translate(359.2007,617.8789)',
      },
      {
        path: 'M 0,0 C 14.487,8.364 52.45,16.992 81.633,-8.011',
        transform: 'translate(362.5234,619.54)',
      },
      {
        path: 'm 0,0 c 0.642,0.34 1.204,-1.087 0.994,-1.784 -0.265,-0.87 -1.186,-1.364 -2.057,-1.104 -1.087,0.326 -1.702,1.472 -1.374,2.56 0.414,1.36 1.852,2.132 3.212,1.725 1.702,-0.508 2.256,-2.315 1.853,-3.491 -0.645,-1.89 -4.651,-2.899 -5.107,0.745',
        transform: 'translate(443.6982,612.4263)',
      },
    ],
  },
  {
    id: 'ten',
    paths: [
      {
        path: 'M 0,0 78.934,94.674',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 123.26290130615234,

        transform: 'translate(150.7007,513.3452)',
      },
      {
        path: 'M 0,0 V -377.536',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 377.5360107421875,

        transform: 'translate(229.6348,608.019)',
      },
      {
        path: 'm 0,0 c -17.746,55.543 -49.49,87.446 -81.136,87.555 -47.635,-0.165 -94.61,-72.37 -94.61,-188.818 0,-116.45 44.884,-188.82 94.61,-188.82 49.727,0 95.496,72.37 95.496,188.82 C 14.36,-62.172 8.969,-28.067 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 918.6231689453125,

        transform: 'translate(478.7334,519.8418)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641',
        transform: 'translate(350.1421,610.6753)',
      },
      {
        path: 'M 0,0 C -30.719,48.322 -82.548,22.098 -93.251,0',
        transform: 'translate(445.4805,613.8994)',
      },
      {
        path: 'M 0,0 C -1.428,6.172 -2.286,10.76 -2.286,10.76M 0,0 C 1.635,6.12 3.031,10.571 3.031,10.571',
        transform: 'translate(249.6348,524.1704)',
      },
      {
        path: 'M 0,0 0.004,74.604',
        transform: 'translate(249.8027,528.1362)',
      },
      {
        path: 'M 0,0 C -2.874,-5.644 -5.164,-9.712 -5.164,-9.712M 0,0 C -5.186,-3.635 -9.116,-6.151 -9.116,-6.151',
        transform: 'translate(192.9468,583.1982)',
      },
      {
        path: 'M 0,0 -47.954,-57.148',
        transform: 'translate(190.269,580.2695)',
      },
      {
        path: 'M 0,0 C -0.727,-0.027 -0.5,-1.543 0.03,-2.042 0.694,-2.663 1.739,-2.63 2.363,-1.969 3.143,-1.143 3.102,0.157 2.273,0.934 1.235,1.905 -0.395,1.855 -1.371,0.822 -2.59,-0.469 -2.167,-2.311 -1.23,-3.127 0.273,-4.441 4.248,-3.312 2.821,0.072',
        transform: 'translate(139.6416,521.2617)',
      },
    ],
  },
];
export default data;
